var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F1F2F4;}\n\t.st1{fill:#464C54;}\n\t.st2{fill:#C9C9C9;}\n\t.st3{fill:#F6CA47;}\n\t.st4{fill:#BFCC58;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#627148;}\n\t.st7{fill:#0076B9;}\n\t.st8{fill:#00A6E4;}\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:#464C54;stroke:#464C54;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#E8E8E8;}\n\t.st12{fill:#D65B36;}\n\t.st13{fill:#D65B4D;}\n\t.st14{fill:none;stroke:#464C54;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 64,
    cy: 64,
    r: 55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77,104c-1.08,0-2.13-0.59-2.66-1.61C72.28,98.45,68.32,96,64,96s-8.28,2.45-10.34,6.39    c-0.77,1.47-2.58,2.04-4.05,1.27c-1.47-0.77-2.04-2.58-1.27-4.05C51.44,93.68,57.44,90,64,90s12.56,3.68,15.66,9.61    c0.77,1.47,0.2,3.28-1.27,4.05C77.95,103.89,77.47,104,77,104z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.96,55.46c-0.45,0-0.9-0.1-1.32-0.31c-1.49-0.73-2.1-2.53-1.37-4.02c3.79-7.7,10.66-13.54,18.87-16.02    c1.59-0.48,3.26,0.42,3.74,2c0.48,1.59-0.42,3.26-2,3.74c-6.62,2.01-12.17,6.72-15.22,12.93C27.14,54.84,26.07,55.46,24.96,55.46z    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 45,
    cy: 61,
    rx: 8,
    ry: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 83,
    cy: 61,
    rx: 8,
    ry: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M101.41,94.25L89,76L76.59,94.25c-4.05,5.96-3.29,13.95,1.8,19.04l0,0c5.86,5.86,15.36,5.86,21.21,0l0,0    C104.7,108.2,105.45,100.21,101.41,94.25z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.04,55.46c-1.11,0-2.17-0.62-2.69-1.68c-3.05-6.21-8.6-10.92-15.22-12.93c-1.58-0.48-2.48-2.16-2-3.74   c0.48-1.59,2.15-2.48,3.74-2c8.21,2.49,15.08,8.33,18.87,16.02c0.73,1.49,0.12,3.28-1.37,4.02   C103.93,55.36,103.48,55.46,103.04,55.46z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/Sad.b969ebe8f9f682f540bd95000b7fb6e1.svg";
export { ForwardRef as ReactComponent };